import React from 'react';
import { createPlanNameMatcher } from '../utils/PlanMetaHelper';
import { IPlanContent } from '../../typings';
import {
  EDRPerkSalesFormContent,
  EverydayRewardsVariablePromoBox,
} from './EverydayRewardsVariablePromobox';
import {
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from '../common/planDefaults';
import { createOnlineCreditsBoxContent } from '../common/onlineCredits';
import { createPromoBoxAccordion } from '../common/createPromoBoxAccordion';

const PromoBox = <EverydayRewardsVariablePromoBox />;
const PromoBoxAuth = <EverydayRewardsVariablePromoBox variant="auth" />;

export const everydayRewardsVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Everyday Rewards Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    bannerContent: {
      defaultState: {
        defaultFuel: '',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        gas: defaultKeyDetails,
        electricity: defaultKeyDetails,
        dual: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    promoBox: {
      defaultState: {
        defaultFuel: PromoBox,
      },
    },
    perkAccordion: createPromoBoxAccordion(),
    perkSalesFormAccordion: {
      defaultState: {
        defaultFuel: [EDRPerkSalesFormContent],
        electricity: [EDRPerkSalesFormContent],
        gas: [EDRPerkSalesFormContent],
      },
    },
    promoBoxAuth: {
      defaultState: {
        defaultFuel: PromoBoxAuth,
      },
    },
    onlineCredits: createOnlineCreditsBoxContent(
      'promoteC',
      '$300 electricity bill credit',
      'New/moving customers only. Plan must be active on 31 December 24 and you must not have received a credit in the previous 12 months. Not redeemable for cash.'
    ),
    estimatesDialog: defaultEstimatesDialog({ onlineCreditAmount: 300 }),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'campaignOrange',
              odsCore: 'promoteC',
            },
            promobox: {
              styleGuide: 'campaignOrange',
              odsCore: 'promoteC',
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl: 'https://res.cloudinary.com/originenergy/image/upload/v1730087684/logo-EDR.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-edr-variable.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'Collect Everyday Rewards points and watch points turn into dollars off your shopping!',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-everyday-rewards-variable/',
      },
    },
  },
};
